module.exports = __webpack_public_path__ + "static/media/excel.f43713ed.svg";